// ** Custom Components
import { StyledText } from "./Text.styled";
import { StyledIcon } from "./Icon.styled";

// ** SVG Static Imports
import { ReactComponent as LightAngleRight } from "resources/icons/light/angle-right.svg";

// #####################################################

export const StyledArrow = () => (
	<StyledText>
		<StyledIcon
			svgIconComponent={LightAngleRight}
			icon="angle-right"
			type="fal"
		/>
	</StyledText>
);

// #####################################################
